import { networkService as network } from '@/services'

export const userOptionService = {
  getUserOptionAll (id) {
    try {
      return new Promise((resolve, reject) => {
        network.get(`/user-options/all/${id}`).then((data) => {
          resolve(data.data[0])
        }).catch((err) => {
          reject(err)
        })
      })
    }
    catch (e) {
      this.createUserOptions({
        user: id
      })
    }

    // return new Promise((resolve, reject) => {
    //   network.get(`/user-options/all/${id}`).then((data) => {
    //     resolve(data.data[0])
    //   }).catch((err) => {
    //     reject(err)
    //   })
    // })
  },

  createUserOptions ({ user, avatarType = 0, isDisplayName = false, canVisitorView = false, canCompanyView = false, canStartChat = false }) {
    return new Promise((resolve, reject) => {
      const request = {
        user,
        avatarType,
        isDisplayName,
        canVisitorView,
        canCompanyView,
        canStartChat,
      }
      network.post(`/user-options`, request).then((data) => {
        resolve(data.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  updateUserOptions ({ user, avatarType = 1, isDisplayName = true, canVisitorView = true, canCompanyView = true, canStartChat = true }) {
    return new Promise((resolve, reject) => {
      this.getUserOptionAll(user)
      .then((data) => {
        let id = data.id;

        const request = {
          id,
          user,
          avatarType,
          isDisplayName,
          canVisitorView,
          canCompanyView,
          canStartChat,
        }
        network.put(`/user-options/${id}`, request).then((data) => {
          resolve(data.data)
        }).catch((err) => {
          reject(err)
        })
      })
    })
  },
}
